<template>
  <TeacherForm
    :title="$t('teacher.editTitle')"
    :submit-text="$t('teacher.saveChanges')"
    :initial-data="initialData"
    :on-submit="handleUpdate"
    :load-data="loadData"
  />
</template>

<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { getTeacherDetail, updateTeacher } from '@/api/teacher'
import TeacherForm from '@/components/TeacherForm.vue'

const route = useRoute()
const router = useRouter()

const initialData = ref({})

const loadData = async () => {
  const id = route.params.id
  if (!id) return {}
  
  const response = await getTeacherDetail(id)
  const data = response.data
  initialData.value = {
    id: data.id || 0,
    name: data.name || '',
    phone: data.phone || '',
    ruleKind: data.ruleKind ?? 0,
    status: data.status ?? 1,
    age: data.age ?? 0,
    workExperienceYear: data.workExperienceYear ?? 0,
    remark: data.remark || '',
    level: data.level ?? 0,
    avatar: data.avatar || '',
    isVisibleForMiniApp: data.isVisibleForMiniApp === true,
    subscribeAllBookingNotifications: data.subscribeAllBookingNotifications === true
  }
  return initialData.value
}

const handleUpdate = async (formData) => {
  const id = route.params.id
  const data = {
    ...formData,
    id: parseInt(id),
    isVisibleForMiniApp: Boolean(formData.isVisibleForMiniApp)
  }
  await updateTeacher(id, data)
  ElMessage.success('Teacher updated successfully')
  router.push('/teacher')
}
</script>
